export type Nullable<T> = T | null

export type Brand<BaseType, TagType> = BaseType & { readonly __tag?: TagType }

export type IdOf<TagType extends string> = Brand<string, TagType>

export type Keys<T> = keyof T

export type Values<T> = T[Keys<T>]

export type ExtractPublicMembers<T> = Pick<T, keyof T>

// biome-ignore lint/suspicious/noExplicitAny: Тип использует только в качестве я extends, иначе невозможно затипизировать
export type AbstractConstructor = abstract new (...args: any) => any
// biome-ignore lint/suspicious/noExplicitAny: Тип использует только в качестве я extends, иначе невозможно затипизировать
export type Constructor = new (...args: any) => any

export type ConstructorOfType<T extends AbstractConstructor> = new (
  ...args: ConstructorParameters<T>
) => InstanceType<T>

export type LegoConstructor<Parameters, ReturnType> = new (...args: Parameters[]) => ReturnType

export type MemoType<V extends Record<string, AbstractConstructor>> = Partial<
  Record<Keys<V>, InstanceType<Values<V>>>
>

export type SelectiveOptionality<T extends object, Keys extends keyof T> = Omit<T, Keys> &
  (
    | {
        [Key in Keys]?: never
      }
    | {
        [Key in Keys]: T[Key]
      }
  )

export type Primitives = string | number | bigint | boolean | symbol | undefined | null
export type NonCollapsableWithPrimitive<T extends Primitives> = Brand<T, Record<never, never>>

export type Prettify<T> = {
  [K in keyof T]: T[K]
} & unknown

export type DeepPartial<T> = T extends object
  ? T extends Function
    ? T
    : {
        [P in keyof T]?: DeepPartial<T[P]>
      }
  : T

export type Tuple<T, N extends number> = N extends N
  ? number extends N
    ? T[]
    : _TupleOf<T, N, []>
  : never

type _TupleOf<T, N extends number, R extends unknown[]> = R['length'] extends N
  ? R
  : _TupleOf<T, N, [T, ...R]>

export type WithPartial<T extends object, K extends keyof T> = Prettify<
  Omit<T, K> & Partial<Pick<T, K>>
>

export type WithRequired<T extends object, K extends keyof T> = Prettify<
  Omit<T, K> & Required<Pick<T, K>>
>

export type KeysOfUnion<T> = T extends T ? Keys<T> : never

export type GetTokenType = () => Nullable<string> | undefined

export type TokenProps = {
  getToken?: GetTokenType
}

export const BaseObjectArray = [
  'well',
  'field',
  'cube',
  'fault',
  'horizon',
  'survey2d',
  'inclinometry',
  'marker',
  'gis',
  'iLine',
  'xLine',
  'Hline',
  'grid',
  'profile',
  'gisName',
  'polygon',
  'map',
  'stick',
  'wellBore',
  'cut',
  'iLineCut',
  'xLineCut',
  'hLineCut',
  'interpretation3D',
  'interpretation2D',
  'lithology',
  'saturation',
  'points',
  'faultsFolder',
  'unknown',
  'vsp',
  'wellsFolder',
  'gisFolder',
  'rigisFolder',
  'markersFolder',
  'seismicFolder',
  'seismicSurveys',
  'interpretation',
  'horizonsFolder',
  'sticksFolder',
  'polygonsFolder',
  'mapsFolder',
  'pointsFolder',
  'gisList',
  'rigisList',
  'vspList',
  'markerList',
  'velocityModel',
  'velocityModelsFolder',
  'virtualFolder',
  'speedLawsFolder',
] as const

type BaseObjectTuple = typeof BaseObjectArray

export type BaseObject = BaseObjectTuple[number]

export type CustomPropertiesType = {
  strokeColor?: string
  fillColor?: string
  fontSize?: string
}

export type CubeLinesType = 'iLine' | 'xLine' | 'Hline'

export type SelectItemKeyed<T = string> = {
  label: string
  key: T
}
